const PERMISSIONS = {
  ANDROID: {
    RECORD_AUDIO: 'android.permission.RECORD_AUDIO',
    POST_NOTIFICATIONS: 'android.permission.POST_NOTIFICATIONS',
    CAMERA: 'android.permission.CAMERA',
    READ_EXTERNAL_STORAGE: 'android.permission.READ_EXTERNAL_STORAGE',
  },
  IOS: {
    MICROPHONE: 'ios.permission.MICROPHONE',
    CAMERA: 'ios.permission.CAMERA',
    PHOTO_LIBRARY: 'ios.permission.PHOTO_LIBRARY',
  },
};

const RESULTS = {
  UNAVAILABLE: 'unavailable',
  DENIED: 'denied',
  BLOCKED: 'blocked',
  GRANTED: 'granted',
  LIMITED: 'limited',
};

const check = async () => RESULTS.GRANTED;
const request = async () => RESULTS.GRANTED;
const checkNotifications = async () => ({ status: RESULTS.GRANTED, settings: {} });
const requestNotifications = async () => ({ status: RESULTS.GRANTED, settings: {} });
const openSettings = async () => {};

module.exports = {
  PERMISSIONS,
  RESULTS,
  check,
  request,
  checkNotifications,
  requestNotifications,
  openSettings,
  default: {
    PERMISSIONS,
    RESULTS,
    check,
    request,
    checkNotifications,
    requestNotifications,
    openSettings,
  }
};
